import defaultPreferencesDialogTemplate from '../consts/default-preferences-template';
/*
 ** Mapping destinations to our categories we expose to the user
 ** this gets fired on saveConsent
 */
var mapCustomPreferences = function (destinations, preferences) {
    // object to store preferences for each destination
    var destinationPreferences = {};
    // object to store preferences for each category
    var customPreferences = preferences;
    // reference of all our possible categories
    var customCategories = defaultPreferencesDialogTemplate.categories;
    customCategories.forEach(function (category) {
        destinations.forEach(function (destination) {
            // if destination matches current category
            if (category.types.includes(destination.category)) {
                if (destinationPreferences[destination.id] !== false) {
                    destinationPreferences[destination.id] =
                        customPreferences[category.key];
                }
            }
        });
    });
    return {
        customPreferences: customPreferences,
        destinationPreferences: destinationPreferences,
    };
};
export default mapCustomPreferences;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwQ3VzdG9tUHJlZmVyZW5jZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvbWFwQ3VzdG9tUHJlZmVyZW5jZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSUEsT0FBTyxnQ0FBZ0MsTUFBTSx3Q0FBd0MsQ0FBQztBQUV0Rjs7O0dBR0c7QUFDSCxJQUFNLG9CQUFvQixHQUFHLFVBQzNCLFlBQTJCLEVBQzNCLFdBQWdDO0lBRWhDLG1EQUFtRDtJQUNuRCxJQUFNLHNCQUFzQixHQUF3QixFQUFFLENBQUM7SUFDdkQsZ0RBQWdEO0lBQ2hELElBQU0saUJBQWlCLEdBQUcsV0FBVyxDQUFDO0lBQ3RDLDJDQUEyQztJQUMzQyxJQUFNLGdCQUFnQixHQUFHLGdDQUFnQyxDQUFDLFVBQVUsQ0FBQztJQUVyRSxnQkFBZ0IsQ0FBQyxPQUFPLENBQUMsVUFBQyxRQUFRO1FBQ2hDLFlBQVksQ0FBQyxPQUFPLENBQUMsVUFBQyxXQUFXO1lBQy9CLDBDQUEwQztZQUMxQyxJQUFJLFFBQVEsQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDLFdBQVcsQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDO2dCQUNsRCxJQUFJLHNCQUFzQixDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsS0FBSyxLQUFLLEVBQUUsQ0FBQztvQkFDckQsc0JBQXNCLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQzt3QkFDcEMsaUJBQWlCLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxDQUFDO2dCQUNwQyxDQUFDO1lBQ0gsQ0FBQztRQUNILENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQyxDQUFDLENBQUM7SUFFSCxPQUFPO1FBQ0wsaUJBQWlCLG1CQUFBO1FBQ2pCLHNCQUFzQix3QkFBQTtLQUN2QixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsZUFBZSxvQkFBb0IsQ0FBQyJ9